import { useQuery } from "@tanstack/react-query";
import { pullDeskOpenChannel } from "./pull";
import { queryKeys } from "@/shared/query/keys";

/** Hydrate / delta-pull desk-open@v1 into IndexedDB; returns active cache. */
export function useDeskOpenCache(
  companySlug: string | undefined,
  enabled: boolean,
) {
  return useQuery({
    queryKey: queryKeys.deskOpen.cache(companySlug ?? ""),
    queryFn: () => pullDeskOpenChannel(companySlug!),
    enabled: Boolean(companySlug) && enabled,
    staleTime: 30_000,
  });
}
